export default {
      id: "admin-with-cogwheels-usage",
      viewBox: "0 0 474.565 474.565",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#admin-with-cogwheels",
      toString: function () {
        return this.url;
      }
    }